module.exports = __webpack_public_path__ + "static/media/mobile3.21de4c3b.png";